import { forwardRef, type PropsWithChildren } from 'react'
import Alert, { type AlertProps } from '../Alert'
import Icon from '../Icon'
import './styles.scss'

type IconAlertProps = AlertProps & { icon?: string }

const renderIcon = (icon?: string) => {
  if (!icon) return null

  return <Icon glyph={icon} width={60} height={80} ariaMode="hidden" />
}

const IconAlert = forwardRef<HTMLDivElement, PropsWithChildren<IconAlertProps>>(
  ({ icon, ...otherProps }, ref) => (
    <Alert ref={ref} aboveTitleContent={renderIcon(icon)} {...otherProps} />
  )
)

IconAlert.displayName = 'Kuiper: IconAlert'

export default IconAlert
